<template>
  <div class="register-card">
    <div class="card-body">
      <div class="glowBox">
        <h4 class="title">ავტორიზაცია სოცქსელით</h4>
        <div class="socialMedia">
          <!-- <a href="/redirect/facebook" class="btn btn-just-icon btn-link">
            <i class="fab fa-facebook-square"></i>
          </a> -->

          <a href="/redirect/google" class="btn btn-just-icon btn-link">
            <i class="fab fa-google-plus"></i>
          </a>
        </div>
      </div>
      <login-form @changeForm="changeForm" :is-show="login && !passwordReset" :unauth="unauth" />

      <register-form
        @changeForm="changeForm"
        :is-show="!login && !passwordReset"
        :unauth="unauth"
      />

      <password-reset-form @changeForm="changeForm" :is-show="passwordReset" :unauth="unauth" />
    </div>
  </div>
</template>

<script>
import LoginForm from './login-form';
import RegisterForm from './register-form';
import PasswordResetForm from './password-reset-form';
export default {
  props: ['unauth'],
  components: {
    LoginForm,
    RegisterForm,
    PasswordResetForm,
  },
  data() {
    return {
      password_msg: false,
      sending: false,
      login: true,
      passwordReset: false,
    };
  },
  methods: {
    changeForm() {
      this.login = !this.login;
      this.passwordReset = false;
    },
    showLogin() {
      this.login = true;
      this.passwordReset = false;
    },
  },
  mounted() {
    // this.login = !this.login;
    // window.showRegister();
  },
};
</script>
